export default __webpack_public_path__ + "static/media/questor-logo-plus.9b77414c.png";